<template>
    <v-app id="inspire" dark class="white-bg">
        <v-toolbar  class="text-xs-center alianza-toolbar" :extended="false" :flat="true" :height="150" app>
          <img style="margin: auto; width: 350px;" src="../../../../assets/logoalianzanv.png" alt="">
        </v-toolbar>
        <main>
          <error-modal :showicon="false" :dialog="dialog" :error="dialogData" @close="closeDialog()"></error-modal>
            <v-content class="own-flex">
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 sm10 md8 lg6 offset-sm1 offset-md2 offset-lg3 d-flex>
                            <v-card light flat>
                                <v-card-text primary-title>
                                    <v-layout row>
                                        <v-flex xs12>
                                            <h3 class="display-1 mb-0">{{getTournamentBasicInfo ? getTournamentBasicInfo.sport_place_name : ''}}</h3>
                                            <h4 class="headline">{{getTournamentBasicInfo ? getTournamentBasicInfo.name : ''}}</h4>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <p class="title">{{ $t("tournament_registration_form_msg_1") }}</p>
                                    </v-layout>
                                    <v-layout row mt-2>
                                        <v-flex xs12>
                                            <span class="grey--text">{{ $t("tournament_registration_form_team_data") }}</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_team_name") }}</label>
                                            <input v-model="formData.team_name"  type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_league_name") }}</label>
                                            <input  v-model="formData.team_league" type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_team_city") }}</label>
                                            <input v-model="formData.team_city" type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row mt-2>
                                        <v-flex xs12>
                                            <span class="grey--text">{{ $t("tournament_registration_form_coach_data") }}</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_name") }}</label>
                                            <input v-model="formData.coach_name" type="text">
                                        </v-flex>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_last_name") }}</label>
                                            <input v-model="formData.coach_lastname" type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_phone") }}</label>
                                            <input v-model="formData.coach_cellphone" type="number">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_email") }}</label>
                                            <input v-model="formData.coach_email" type="email">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_email_confirm") }}</label>
                                            <input v-model="formData.coach_email_confirm"  type="email">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_country") }}</label>
                                            <input v-model="formData.coach_country" type="text">

                                        </v-flex>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_state") }}</label>
                                            <input v-model="formData.coach_city" type="text">

                                        </v-flex>
                                        <v-flex xs12 sm6 class="input-group">
                                            <label>{{ $t("tournament_registration_form_coach_postal_code") }}</label>
                                            <input v-model="formData.coach_postal_code" type="number">
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row mt-2>
                                        <v-flex xs12 class="input-group">
                                            <span class="grey--text">{{ $t("tournament_registration_form_coach_social_data") }}</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>Facebook</label>
                                            <input v-model="formData.fb" type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>Instagram</label>
                                            <input v-model="formData.instagram" type="text">
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="input-group">
                                            <label>{{ $t("tournament_registration_form_how_do_you_find") }}</label>
                                            <select>
                                                <option value="">Select</option>
                                                <option v-for="option of options" value="">
                                                    {{ option.text }}
                                                </option>
                                            </select>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn @click="send()">{{ $t("tournament_registration_form_send_btn") }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </main>
        <v-footer app fixed>
            <span>&copy; 2017</span>
        </v-footer>
    </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'

/*TODO eliminar esto y dejar todo lo de idiomas a nivel global en la app*/
import axios from 'axios'

export default {
    name: 'TournamentRegistrationForm',
    data() {
        return {
          savedData: false,
          tournamentId:-1,
            states: [
                { text: 'State 1' },
                { text: 'State 2' },
                { text: 'State 3' },
                { text: 'State 4' },
                { text: 'State 5' },
                { text: 'State 6' },
                { text: 'State 7' }
            ],
            options: [
                { text: this.$t('tournament_registration_form_how_do_you_find_1') },
                { text: this.$t('tournament_registration_form_how_do_you_find_2') },
                { text: this.$t('tournament_registration_form_how_do_you_find_3') },
                { text: this.$t('tournament_registration_form_how_do_you_find_4') },
                { text: this.$t('tournament_registration_form_how_do_you_find_5') },
                { text: this.$t('tournament_registration_form_how_do_you_find_6') },
                { text: this.$t('tournament_registration_form_how_do_you_find_7') },
                { text: this.$t('tournament_registration_form_how_do_you_find_8') },
                { text: this.$t('tournament_registration_form_how_do_you_find_9') },
                { text: this.$t('tournament_registration_form_how_do_you_find_10') },
                { text: this.$t('tournament_registration_form_how_do_you_find_11') },
                { text: this.$t('tournament_registration_form_how_do_you_find_12') }
            ],
            formData:{
              team_league:"",
              team_name: "",
              team_city: "",
              coach_name: "",
              coach_lastname: "",
              coach_cellphone:"",
              coach_email: "",
              coach_email_confirm: "",
              coach_country: "",
              coach_city:"",
              coach_postal_code: "",
              fb: "",
              instagram: ""

            },
            dialog: false,
            dialogData: {
              code: 500,
              title: 'Server Error',
              message: 'Error'
            }
        }

    },
    computed:{
      ...mapGetters([
        'getTournamentBasicInfo'
      ])
    },
    methods: {
      ...mapActions([
        'loadTournamentBasicInfo',
        'createRegistration',
        'goBack',
        'setLang'
      ]),
      send(){
        if(this.formData.coach_email_confirm != this.formData.coach_email){
          this.showDialog("alerts_error_title", 'tournament_registration_form_confirmation_email_error')
          return
        }
        var data = {
          team_league: this.formData.team_league,
          tournamentId: this.tournamentId,
          team_name: this.formData.team_name,
          team_city: this.formData.team_city,
          coach_name: this.formData.coach_name,
          coach_lastname: this.formData.coach_lastname,
          coach_cellphone: this.formData.coach_cellphone,
          coach_email: this.formData.coach_email,
          coach_country: this.formData.coach_country,
          coach_city: this.formData.coach_city,
          coach_postal_code: this.formData.coach_postal_code/*,
          fb: this.formData.fb,
          instagram: this.formData.instagram*/

        }
        if(this.formData.fb.length > 0){
          //data.fb = this.formData.fb
        }
        if(this.formData.instagram.length > 0){
          //data.instagram = this.formData.instagram
        }
        data.callback = () => {
          this.savedData = true
          this.showDialog("",'tournament_registration_form_thanks')
        }
        console.log(data)
        this.createRegistration(data)
      },
      showDialog(title, msg){
        this.dialogData.title = title
        this.dialogData.message = msg
        this.dialog = true
      },
      closeDialog(){
        this.dialog = false
        if(this.savedData){
          this.goBack()
        }

      }
    },
    mounted() {
      this.tournamentId = this.$route.params.tournamentID
      this.setLang(this.$route.params.lang)
      /*TODO eliminar esto y dejar todo lo de idiomas a nivel global en la app*/
      axios.defaults.headers.common["lang"] = this.$route.params.lang
      //do something after mounting vue instance
      this.loadTournamentBasicInfo(this.tournamentId)
    },
    created() {
      //do something after creating vue instance
      Bus.$on(Bus.ACTION_SHOW_ALERT, event => {
        this.showDialog(event.title, event.msg)
      })
    }
}

</script>

<style lang="css" scoped>
    .input-group label {
        color: black !important;
        font-weight: bold;
        margin-bottom: 5px;
        max-width: 100%;
    }

    .input-group input,
    .input-group select {
        width: 100%;
        border: 1px solid #D6D6D6;
        border-radius: 3px;
        height: 38px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        background: #FFFFFF;
        padding: 5px 4px;
        color: black !important;
    }

    h6.headline{
      font-size: 15px !important;
    }
    .white-bg{
      background: #FFFFFF;
    }
    img.alianza-logo{
      margin: auto;
      width: 350px;
      display: block;
    }

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_registration/tournamentRegistrationForm.vue